












import BroadcastManager from "@/components/General/BroadcastManager/BroadcastManager.vue";
import PageTemplate from "@/components/PageTemplate.vue";
import { RouteName } from "@/router/types";
import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    PageTemplate,
    BroadcastManager,
  },
})
export default class BroadcastManagerView extends Vue {
  RouteName = RouteName;
}
